import { getRequestTransportErrorMessage } from '#/utils/requestError';

export function getStockIssueCategoryApiErrorMessage(
  error,
  fallback = '操作失敗，請稍後再試',
) {
  const transportMessage = getRequestTransportErrorMessage(error);
  if (transportMessage) {
    return transportMessage;
  }

  const data = error?.response?.data;
  const code = data?.code || data?.error?.code;

  if (code === 'RESOURCE_VERSION_CONFLICT') {
    return data?.message || '資料已被他人修改，請重新載入後再試';
  }

  if (code === 'STOCK_ISSUE_CATEGORY_NOT_FOUND'
    || code === 'SYSTEM_STOCK_ISSUE_CATEGORY_NOT_FOUND') {
    return data?.message || '找不到出庫類別資料';
  }

  if (code === 'UPDATED_AT_REQUIRED') {
    return data?.message || '缺少更新時間，請重新載入後再試';
  }

  return data?.message || fallback;
}

export function isStockIssueCategoryVersionConflict(error) {
  const data = error?.response?.data;
  return (data?.code || data?.error?.code) === 'RESOURCE_VERSION_CONFLICT';
}
